import { createContext, ReactElement } from 'react'
import { Location, RouterOptions } from '../types'

export const LocationContext = createContext<Location>('')
export interface IRouteContext {
  outlet?: ReactElement
  location?: Location
  locationSoFar?: Location
  completeLocationSoFar?: Location
}
export const RouteContext = createContext<IRouteContext>({})

export interface IPanelContext {
  name: string
  parent: string | null
}
export const PanelContext = createContext<IPanelContext>({
  name: 'root',
  parent: null,
})

export interface ISectionContext {
  name?: string
}
export const SectionContext = createContext<ISectionContext>({})

export const OptionsContext = createContext<RouterOptions>({
  disableAnimations: false,
})
